import { createFeatureSelector } from '@ngrx/store';

import { AppState } from '@app/sharedModule/models/app-state.model';
import * as fromDeletedOrders from '../reducers';

export const deletedSelector = createFeatureSelector<AppState, fromDeletedOrders.DeletedOrdersState>(
  fromDeletedOrders.featureKey,
);
